import React from "react";
import BelgiumDashboard from "./BelgiumDashboard";
import GreeceDashboard from "./GreeceDashboard";
import SpainDashboard from "./SpainDashboard";
import ScreeningPolicyCard from "./ScreeningPolicyCard";

export default function CountryDashboard({ country, metas, dataById, policyData }) {
  // Show policy card even if no metas for countries without dashboards
  if (!metas?.length && !policyData) return null;

  switch ((country || "").toLowerCase()) {
    case "belgium":
      return <BelgiumDashboard metas={metas} dataById={dataById} policyData={policyData} />;
    case "greece":
      return <GreeceDashboard dataById={dataById} policyData={policyData} />; // uses IDs directly
    case "spain": // 👈 NEW
      return <SpainDashboard dataById={dataById} policyData={policyData} />;
    default:
      // Fallback: show policy card for countries without custom dashboards
      return (
        <div className="chart-grid">
          {policyData && <ScreeningPolicyCard policyData={policyData} />}
          <div className="chart-card" style={{ gridColumn: "1 / -1" }}>
            <div style={{ padding: 24, textAlign: "center" }}>
              <h3 style={{ margin: "0 0 12px 0", fontSize: 18, fontWeight: 600 }}>
                Full Dashboard Coming Soon
              </h3>
              <p style={{ margin: 0, opacity: 0.7, fontSize: 14 }}>
                The complete dashboard with detailed visualizations for {country} is currently under development.
                You can view the CRC Screening Policy information above.
              </p>
            </div>
          </div>
        </div>
      );
  }
}
